import { computed, ref, watch } from 'vue';

export function useKanbanColumns(board, tickets, isUpdatingFromDrag) {
  const columns = computed(() => {
    const cols = (board.value && board.value.board_columns) || [];
    const getColor = name => {
      const colorMap = {
        Aberto: 'bg-blue-100 dark:bg-blue-900',
        Andamento: 'bg-yellow-100 dark:bg-yellow-900',
        Pendente: 'bg-orange-100 dark:bg-orange-900',
        Cliente: 'bg-purple-100 dark:bg-purple-900',
        Resolvido: 'bg-green-100 dark:bg-green-900',
        Finalizado: 'bg-green-100 dark:bg-green-900',
        Cancelado: 'bg-red-100 dark:bg-red-900',
      };
      return colorMap[name] || 'bg-gray-100 dark:bg-gray-900';
    };
    return cols.map(c => ({
      id: c.id || c.position,
      name: c.name,
      color: getColor(c.name),
    }));
  });

  const getTicketsByColumn = column => {
    if (!tickets.value || !board.value) return [];

    // Filtrar tickets por board_id e board_column_id
    return tickets.value.filter(ticket => {
      return (
        ticket.board_id === board.value.id && ticket.board_column_id === column.id
      );
    });
  };

  // Criar listas mutáveis para cada coluna para permitir drag and drop
  const columnTickets = ref({});

  watch(
    [tickets, board, columns],
    () => {
      // Não atualizar durante o drag para não reverter as mudanças locais
      if (isUpdatingFromDrag?.value) return;

      if (!tickets.value || !board.value || !columns.value.length) {
        columnTickets.value = {};
        return;
      }

      const newColumnTickets = {};
      columns.value.forEach(column => {
        newColumnTickets[column.id] = [...getTicketsByColumn(column)];
      });
      columnTickets.value = newColumnTickets;
    },
    { immediate: true, deep: true }
  );

  const updateColumnTickets = () => {
    if (!tickets.value || !board.value || !columns.value.length) {
      columnTickets.value = {};
      return;
    }

    const newColumnTickets = {};
    columns.value.forEach(column => {
      newColumnTickets[column.id] = [...getTicketsByColumn(column)];
    });
    columnTickets.value = newColumnTickets;
  };

  const updateColumnsTickets = columnIds => {
    if (!tickets.value || !board.value || !columns.value.length || !columnIds?.length) {
      return;
    }

    const updates = {};
    columnIds.forEach(colId => {
      const column = columns.value.find(
        c => c.id === colId || c.id?.toString() === String(colId)
      );
      if (column) {
        updates[column.id] = [...getTicketsByColumn(column)];
      }
    });
    if (Object.keys(updates).length > 0) {
      columnTickets.value = { ...columnTickets.value, ...updates };
    }
  };

  return {
    columns,
    columnTickets,
    getTicketsByColumn,
    updateColumnTickets,
    updateColumnsTickets,
  };
}

